import React from 'react';
import { motion } from 'framer-motion';
import { Typography } from '@mui/material'; // Import Typography from MUI

interface FlipCardProps {
    front: string;
    back: string;
    flipped: boolean; // Now controlled by parent
    onFlip: () => void; // Callback to notify parent of flip request
}

const FlipCard: React.FC<FlipCardProps> = ({ front, back, flipped, onFlip }) => {
    return (
        <motion.div
            // Container for the flip card, handles the click to trigger flip
            className="w-full max-w-xs h-64 relative cursor-pointer"
            style={{ perspective: '1000px' }} // Required for 3D transform
            onClick={onFlip} // Use the onFlip prop to toggle state in parent
            initial={false} // Disable initial animation as state is controlled
        >
            <motion.div
                // Inner container that performs the 3D rotation
                className="relative w-full h-full rounded-xl shadow-lg"
                style={{ transformStyle: 'preserve-3d' }} // Enable 3D transformations for children
                animate={{ rotateY: flipped ? 180 : 0 }} // Animate rotation based on 'flipped' prop
                transition={{ duration: 0.6, ease: "easeInOut" }} // Smooth transition for the flip
            >
                {/* Front of the card */}
                <div
                    // Position absolute to stack front and back, backface-hidden to hide back when rotated
                    className="absolute w-full h-full rounded-xl shadow-lg flex flex-col items-center justify-center p-4 text-center
                               bg-pink-100 text-pink-700 border-2 border-pink-200
                               dark:bg-gray-700 dark:text-pink-200 dark:border-gray-600"
                    style={{ backfaceVisibility: 'hidden' }}
                >
                    <Typography variant="h3" className="font-bold leading-tight">
                        {front}
                    </Typography>
                </div>

                {/* Back of the card */}
                <div
                    // Rotated 180deg initially so it's hidden behind the front
                    className="absolute w-full h-full rounded-xl shadow-lg flex flex-col items-center justify-center p-4 text-center
                               bg-blue-100 text-blue-700 border-2 border-blue-200
                               dark:bg-gray-700 dark:text-blue-200 dark:border-gray-600"
                    style={{ backfaceVisibility: 'hidden', transform: 'rotateY(180deg)' }}
                >
                    <Typography variant="h4" className="font-bold leading-tight">
                        {back}
                    </Typography>
                </div>
            </motion.div>
        </motion.div>
    );
};

export default FlipCard;